
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'

// import {  articleDetail } from "@/api/common";
import getPageTitle from '@/utils/get-page-title'
import { mapGetters } from 'vuex'

export default {
	components: {
		TitleBox,
		TitleBox2
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo'
		})
	},
	data() {
		return {
			// 显示第二个titleBox标题
			showDesc: false,
			leftImg: '',
			title: '', // 标题
			titleBoxTitle: '', // 第一个titleBox标题
			descTitle: '', // 第二个titleBox标题
			articleContent: '<p class="tc f18 text-aaa mt-115">加载中...</p>' // 内容
		}
	},
	mounted() {
		// 出售指南
		this.getPageData()
	},
	methods: {
		back() {
			this.$router.go(-1)
		},

		getPageData() {
			this.showDesc = false
			this.title = this.titleBoxTitle = '出售指南'
			this.getArticle()
			document.title = getPageTitle(this.title)
		},
		getArticle() {
			let p = {
				action: {
					title: this.title
				}
			}
			this.$api.articleDetail(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.articleContent = res.data ? res.data.content : '<p class="tc f18 text-aaa mt-115">暂无内容</p>'
			})
		}
	}
}
